var __rspack_ns_object = JSON.parse('{"Measurements":"Medidas","Studies":"Estudos"}')